import { render, staticRenderFns } from "./AuditDetail.vue?vue&type=template&id=1ffa434a&scoped=true"
import script from "./AuditDetail.vue?vue&type=script&lang=js"
export * from "./AuditDetail.vue?vue&type=script&lang=js"
import style0 from "./AuditDetail.vue?vue&type=style&index=0&id=1ffa434a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa434a",
  null
  
)

export default component.exports